import scaleForGradient from "views/components/sidebar/highlighting/Scale";
class HighlightingColor {
  static fromJSON(json) {
    switch (json.type) {
      case "gradient":
        return GradientColor.fromJSON(json);
      case "static":
        return StaticColor.fromJSON(json);
      default:
        throw new Error(`Invalid highlighting color type: ${json.type}`);
    }
  }
  isStatic() {
    return this.type === "static";
  }
  isGradient() {
    return this.type === "gradient";
  }
}
export class StaticColor extends HighlightingColor {
  constructor(color) {
    super();
    this._color = color;
  }
  // eslint-disable-next-line class-methods-use-this
  get type() {
    return "static";
  }
  get color() {
    return this._color;
  }
  colorFor() {
    return this.color;
  }
  static fromJSON({ color }) {
    return new StaticColor(color);
  }
  static create(color) {
    return new StaticColor(color);
  }
  toJSON() {
    const { color } = this;
    return {
      type: "static",
      color
    };
  }
}
const parseValue = (value, defaultValue = 0) => {
  if (typeof value === "number") {
    return value;
  }
  try {
    return Number.parseFloat(value);
  } catch (ignored) {
    return defaultValue;
  }
};
export class GradientColor extends HighlightingColor {
  constructor(gradient, lower, upper) {
    super();
    this._lower = lower;
    this._upper = upper;
    this._gradient = gradient;
    this._scale = scaleForGradient(gradient);
  }
  // eslint-disable-next-line class-methods-use-this
  get type() {
    return "gradient";
  }
  get gradient() {
    return this._gradient;
  }
  get lower() {
    return this._lower;
  }
  get upper() {
    return this._upper;
  }
  get scale() {
    return this._scale;
  }
  colorFor(value) {
    const parsedValue = parseValue(value, this.lower);
    const spread = this.upper - this.lower;
    const normalizedValue = Math.max(this.lower, Math.min(this.upper, parsedValue));
    return this._scale((normalizedValue - this.lower) / spread).hex();
  }
  static fromJSON({ gradient, lower, upper }) {
    return new GradientColor(gradient, lower, upper);
  }
  static create(gradient, lower, upper) {
    return new GradientColor(gradient, lower, upper);
  }
  withGradient(gradient) {
    return GradientColor.create(gradient, this.lower, this.upper);
  }
  withLower(lower) {
    return GradientColor.create(this.gradient, lower, this.upper);
  }
  withUpper(upper) {
    return GradientColor.create(this.gradient, this.lower, upper);
  }
  toJSON() {
    const { gradient, lower, upper } = this;
    return {
      type: "gradient",
      gradient,
      lower,
      upper
    };
  }
}
export default HighlightingColor;
